audioContext = window.AudioContext or window.webkitAudioContext

module.exports = if audioContext? and Promise?
  require './sound-audio-api'
else
  require './sound-html'

